import {ETimePeriod, ETimePickerType} from './types';

export default {
  timePlaceholder: {
    [ETimePickerType.HMS]: 'чч:мм:сс',
    [ETimePickerType.HM]: 'чч:мм',
    [ETimePickerType.MS]: 'мм:сс',
  },
  options: {
    [ETimePeriod.HOURS]: 'Час',
    [ETimePeriod.MINUTES]: 'Мин',
    [ETimePeriod.SECONDS]: 'Сек',
  },
  acceptButton: 'Ок',
};
